import * as Types from '../../../../graphql/__generated__/globalTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateNewJobMutationVariables = Types.Exact<{
  jobInput: Types.CreateJobInput;
}>;


export type CreateNewJobMutation = { __typename?: 'Mutation', createNewJob: { __typename?: 'Job', throwAway?: boolean | null } };


export const CreateNewJobDocument = gql`
    mutation CreateNewJob($jobInput: CreateJobInput!) {
  createNewJob(jobInput: $jobInput) {
    throwAway
  }
}
    `;
export type CreateNewJobMutationFn = Apollo.MutationFunction<CreateNewJobMutation, CreateNewJobMutationVariables>;

/**
 * __useCreateNewJobMutation__
 *
 * To run a mutation, you first call `useCreateNewJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNewJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNewJobMutation, { data, loading, error }] = useCreateNewJobMutation({
 *   variables: {
 *      jobInput: // value for 'jobInput'
 *   },
 * });
 */
export function useCreateNewJobMutation(baseOptions?: Apollo.MutationHookOptions<CreateNewJobMutation, CreateNewJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNewJobMutation, CreateNewJobMutationVariables>(CreateNewJobDocument, options);
      }
export type CreateNewJobMutationHookResult = ReturnType<typeof useCreateNewJobMutation>;
export type CreateNewJobMutationResult = Apollo.MutationResult<CreateNewJobMutation>;
export type CreateNewJobMutationOptions = Apollo.BaseMutationOptions<CreateNewJobMutation, CreateNewJobMutationVariables>;